import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";


export const getLoginReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/login?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadLoginReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/login?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getLectureReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/lecture?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getOnDemandLectureReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/ondemandlecture?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadLectureReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/lecture?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getTestListByCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/report/course/wise/test?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTestReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/test/prelims?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadAttemptTestReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/test/prelims?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getMainsTestReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/test/mains?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadMainsAttemptTestReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/test/mains?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getExceptionalLectureReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/exception?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getAffiliateMacIDs = async (data) => {
  return decryptData(
    await axios.get(
      `/affiliate-srbilling-macids?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const updateAffiliateMacID = async (data) => {
  return decryptData(
    await axios.get(
      `/reset-macids?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const resetAffiliateMacID = async (data) => {
  return decryptData(
    await axios.get(
      `/reset-srbilling-macid?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadExceptionalLectureReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/exception?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getGroupMeetingReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/groupmeeting?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getLectureAttemptLog = async (data) => {
  return decryptData(
    await axios.get(
      `/report/lecture-attempt-log?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getPiracyAttemptReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/piracy-attempt-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getKnoxApiErrorList = async (data) => {
  return decryptData(
    await axios.get(
      `/report/knox-api-error-log?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadGroupMeetingReport = async (data) => {
  return `${process.env.REACT_APP_API_URL
    }/admin/report/groupmeeting?reqData=${encryptData({
      ...data,
      access_token: isLoggedIn(),
    })}`;
};

export const getAffiliateBillingDetails = async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-billing-details-by-affiliateid?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getReportCourses = async (data) => {
  return decryptData(
    await axios.get(
      `/get-report-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getDataForSRreport = async (data) => {
  return decryptData(
    await axios.get(
      `/import-data-for-srreport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getPSIRStudentList = async (data) => {
  return decryptData(
    await axios.get(
      `/get-psir-student-list?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const downloadExcelPSIR = async (data) => {
  return decryptData(
    await axios.get(
      `/get-psir-student-excel-export?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTestStudentCount = async (data) => {
  return decryptData(
    await axios.get(
      `/get-test-student-count-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTestStudentAttendanceCount = async (data) => {
  return decryptData(
    await axios.get(
      `/get-test-student-attendance-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTestStudentDetails = async (data) => {
  return decryptData(
    await axios.get(
      `/get-test-student-detail-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getTestStudentAttendanceDetail = async (data) => {
  return decryptData(
    await axios.get(
      `/get-test-student-attendance-detail-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getAdmissionSummaryReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/get-active-and-inactive-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getAdmissionCount = async (data) => {
  return decryptData(
    await axios.get(
      `/report/get-admission-summary-report?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getAdmissionByAffiliate = async (data) => {
  return decryptData(
    await axios.get(
      `/get-admission-done-by-affiliates?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ************************************ Student With Default Courses ********************************************
export const getStudentWithDefaultCouresList = async (data) => {
  return decryptData(
    await axios.get(
      `/GetUserswithOnlyDefaultCourses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const enrollStudentTab = async (data) => {
  return decryptData(
    await axios.post(`addTabStudentRecord`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getCourseDetailsVisitReport = async (data) => {
  return decryptData(
    await axios.get(
      `/getCourseDetailsVisitReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getSubscriptionPageDetailsVisitReport = async (data) => {
  return decryptData(
    await axios.get(
      `/getSubscriptionPageDetailsVisitReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ************************************ billing transaction pending report **************************************

export const getMocktestRegistrationReport = async (data) => {
  return decryptData(
    await axios.get(
      `/mocktest-registration-report
?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getExportToExcelMocktestRegistrationReport = async (data) => {
  return decryptData(
    await axios.get(
      `/mocktest-registration-report-excel-export
?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ************************************ billing transaction pending report **************************************
export const getBillingTransactionPendingList = async (data) => {
  return decryptData(
    await axios.get(
      `/getBillingTransactionPendingList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

// ************************************ System Access Report **************************************
export const getSystemAccessReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getSystemAccessReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getExportToExcelSystemAccessReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getSystemAccessReport
?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getStudentDetailsByIMEIorEmail = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getStudentDetailsByIMEIorEmail
?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const UpdateDeviceTag = async (data) => {
  return decryptData(
    await axios.post(`/report/UpdateDeviceTag`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const updateTabletPortal = async (data) => {
  return decryptData(
    await axios.post(`/report/updateTabletPortal`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const uploadExcelFileToUpdateIMEIBulk = async (data) => {
  return decryptData(
    await axios.post(`update-device-tag-bulk`, data, setMultiPartHeader())
  );
};
export const updateTabRecordsBulk = async (data) => {
  return decryptData(
    await axios.post(`update-tab-records-bulk`, data, setMultiPartHeader())
  );
};
export const getRefundListReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getRefundListReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getDeviceIDLogReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getDeviceIDLogReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getExpMobileAccessReport = async (data) => {
  return decryptData(
    await axios.get(
      `/report/getMobileExpCourseAccessReport?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};